import type { AnalyticsData } from "../types/data";
import type { ColumnKey } from "../types/ui";
import { Key } from "../constants/enums";

export type GroupedData = Array<{ label: string; items: AnalyticsData[] }>;

export const groupData = (data: AnalyticsData[], groupBy: Key): GroupedData => {
  return data.reduce((acc, item) => {
    const value = item[groupBy as keyof AnalyticsData] as ColumnKey;
    const label = value.label;

    if (!acc.length || acc[acc.length - 1].label !== label) {
      acc.push({ label, items: [item] });
    } else {
      acc[acc.length - 1].items.push(item);
    }
    return acc;
  }, [] as GroupedData);
};

/**
 * Splits grouped rows into pages of `groupsPerPage` groups, so each page holds a
 * fixed number of groups (e.g. students) regardless of how many rows each group
 * contains. Groups are never broken across a page boundary.
 */
export const paginateGroups = (
  groups: GroupedData,
  groupsPerPage: number,
): GroupedData[] => {
  if (groups.length === 0) return [];
  const pages: GroupedData[] = [];
  for (let i = 0; i < groups.length; i += groupsPerPage) {
    pages.push(groups.slice(i, i + groupsPerPage));
  }
  return pages;
};

export const getRoundedClasses = (
  itemIndex: number,
  totalItems: number,
): string => {
  const isFirst = itemIndex === 0;
  const isLast = itemIndex === totalItems - 1;

  if (isFirst && isLast) {
    return "rounded-lg";
  }
  if (isFirst) {
    return "rounded-t-lg";
  }
  if (isLast) {
    return "rounded-b-lg";
  }
  return "";
};
